export enum ProgressBarStatus {
  default = 'default',
  processing = 'processing',
  completed = 'completed'
}